import { render } from "./cameratest.vue?vue&type=template&id=c5b3a4c4"
import script from "./cameratest.vue?vue&type=script&lang=js"
export * from "./cameratest.vue?vue&type=script&lang=js"

import "./cameratest.vue?vue&type=style&index=0&id=c5b3a4c4&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__